export default __webpack_public_path__ + "static/media/edit.aa880ae8.svg";